import { render } from "./LetterConstructorComponent.vue?vue&type=template&id=f9368580"
import script from "./LetterConstructorComponent.vue?vue&type=script&lang=js"
export * from "./LetterConstructorComponent.vue?vue&type=script&lang=js"

import "./LetterConstructorComponent.vue?vue&type=style&index=0&id=f9368580&lang=css"

import exportComponent from "/Users/dmitriy-pc/Projects/docs.d-services.ru/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__